import { createContext, useContext } from 'react';

export interface UnreadContextValue {
  unreadSummaryCount: number;
  unreadNoticeMinistries: Set<string>;
  markSummaryRead: (id: string) => void;
  reportMinistryUnreads: (ministry: string, count: number) => void;
  decrementUnreadCount: () => void;
}

export const UnreadContext = createContext<UnreadContextValue>({
  unreadSummaryCount: 0,
  unreadNoticeMinistries: new Set(),
  markSummaryRead: () => {},
  reportMinistryUnreads: () => {},
  decrementUnreadCount: () => {}
});

export function useUnread() {
  return useContext(UnreadContext);
}
